import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
// import login from "../assets/Login/login.png";
// import logo from "../assets/Login/aliklogo.png";
import img from "../assets/contact/cuate.png";
import location from "../assets/contact/Location.png";
import mail from "../assets/contact/Email.png";
import phone from "../assets/contact/Phone.png";

const ContactUs = () => {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Submitted:", form);
        // Add email API or backend call
        alert("Message submitted successfully!");
        setForm({ name: "", email: "", subject: "", message: "" });
    };

    return (
        // <div className="min-h-screen flex flex-col bg-[#F7F7F7] ">
        <div className="min-h-screen flex flex-col bg-[white] ">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            <div className="bg-[#8B0000] h-[100px] md:h-[150px] flex justify-around p-6 md:p-8">
                <div>
                    <h1 className="text-[white] font-[700] text-[18px] md:text-[40px] tracking-wide">Contact Us</h1>
                    <p className="text-[white] tracking-wider text-[12px] md:text-lg">We would love to hear from you</p>
                </div>
                <div>
                    <img src={img} alt="contact" className="ml-auto md:mr-[100px] w-[55%]" />
                </div>
            </div>

            <div className="h-full flex flex-col items-center p-5 md:mt-8">
                <div className="flex bg-[white] rounded-r-0 lg:rounded-[51px] max-w-5xl justify-between gap-6">
                    <div className=" md:w-[50%] p-8 hidden md:block">
                        <h1 className="font-[700] text-[30px] my-5"> Let's talk </h1>
                        <p className="font-[400] tracking-wide">Questions, comments, or suggestions?</p>
                        <p className="font-[400] tracking-wide">Simply fill in the form and we'll be in touch shortly.</p>
                        <div className="flex mt-5 py-2 gap-2.5">
                            <img src={location} alt="location" />
                            <h3 className="font-[500]">Location</h3>
                        </div>
                        <div className="flex py-2 gap-2">
                            <img src={mail} alt="phone" />
                            <h3 className="font-[500]">Phone</h3>
                        </div>
                        <div className="flex py-2 gap-2.5">
                            <img src={phone} alt="email" />
                            <h3 className="font-[500]">Email</h3>
                        </div>
                    </div>
                    <div className=" md:w-[50%] p-8 items-center shadow-md rounded-lg">
                        <form onSubmit={handleSubmit} className="space-y-4">
                            {/* <div className="flex justify-center items-center w-[100%] h-[10%] my-8">
                                <div className=" w-[50%] h-[100%]">
                                    <img src={logo} alt="logo" style={{ height: "100%", width: "100%" }} />
                                </div>
                            </div> */}
                            <div className="flex gap-4">
                                <div>
                                    {/* <label className="block lg:text-md text-base font-[600] font-display text-[#8B0000]">
                                        First Name
                                    </label> */}
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={form.firstName}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-4 py-2 border border-[#D1D5DB] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 font-display lg:text-md text-sm font-[500]"
                                        placeholder="First Name"
                                    />
                                </div>
                                <div>
                                    {/* <label className="block lg:text-md text-base font-[600] font-display text-[#8B0000]">
                                        Last Name
                                    </label> */}
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={form.lastName}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-4 py-2 border border-[#D1D5DB] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 font-display lg:text-md text-sm font-[500]"
                                        placeholder="Last Name"
                                    />
                                </div>
                            </div>

                            <div>
                                {/* <label className="block lg:text-md text-base font-[600] font-display text-[#8B0000]">
                                    Email
                                </label> */}
                                <input
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-2 border border-[#D1D5DB] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 font-display lg:text-md text-sm font-[500]"
                                    placeholder="Email"
                                />
                            </div>

                            <div>
                                {/* <label className="block lg:text-md text-base font-[600] font-display text-[#8B0000]">
                                    Phone
                                </label> */}
                                <input
                                    type="tel"
                                    name="phone"
                                    value={form.subject}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-2 border border-[#D1D5DB] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 font-display lg:text-md text-sm font-[500]"
                                    placeholder="Phone Number"
                                />
                            </div>

                            <div>
                                {/* <label className="block lg:text-md text-base font-[600] font-display text-[#8B0000]">
                                    Message
                                </label> */}
                                <textarea
                                    name="message"
                                    value={form.message}
                                    onChange={handleChange}
                                    rows="5"
                                    required
                                    className="w-full px-4 py-2 border border-[#D1D5DB] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 font-display lg:text-md text-sm font-[500]"
                                    placeholder="Your message..."
                                ></textarea>
                            </div>

                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="px-6 py-2 bg-blue-900 font-[600] bg-[#8B0000] font-display text-[white] rounded-lg "
                                >
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="mt-7">
                <Footer />
            </div>
        </div>
    );
};

export default ContactUs;
